// Gate ÚNICO do POC Partytown (GTM no web worker). Usado tanto no _document
// (loader, host vem do req) quanto no _app (rewrite do <script> do GTM, host vem
// das props). Os DOIS precisam usar o MESMO critério — senão um host gera o
// script text/partytown SEM o loader (ou vice-versa) e o GTM morre (perde tracking).
const PARTYTOWN_HOSTS = new Set<string>(['parcelacertaimoveis.com.br']);

export function shouldUsePartytown(host: unknown, codsite: unknown): boolean {
  const h = String(host || '')
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '')
    .toLowerCase()
    .split('/')[0]
    .split(':')[0];
  if (!h) return false;
  if (PARTYTOWN_HOSTS.has(h)) return true;
  const cs = Array.isArray(codsite) ? codsite[0] : codsite;
  if (h.startsWith('testesite.') && String(cs ?? '') === '2060') return true;
  return false;
}
